import animationData from "../../assets/animations/LogoJson/JSON_Logo/JSON_EXP/data.json";
export const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};